import React from 'react';
import { Selector as PropsSelector } from '@/models/Props';

import linkedInLogo from '@/assets/in.svg';
import facebookLogo from '@/assets/fb.svg';
import globe from '@/assets/globe.svg';

import './Footer.scss';
import SupportModal from '../../../pages/SupportModal/SupportModal';
import footerLogo from '../../../assets/co2logic-footer.svg';
import AlertWrapper from '../../../pages/AlertWrapper/AlertWrapper';
import useStore from '@/stores/useStore';

const Footer = ({ ariaLabel, branding, translation }: PropsSelector) => {
    const data = useStore((state) => state.data);
    const [showSupportModal, setShowSupportModal] = React.useState(false);
    const [showAlert, setShowAlert] = React.useState(false);
    const goto = (url: string) => {
        if (url) window.open(url, '_blank');
    };
    return (
        <>
            {showAlert && (
                <AlertWrapper
                    type='success'
                    message={translation('support.emailSentSuccessMessage')}
                    onClose={() => setShowAlert(false)}
                />
            )}
            {showSupportModal && (
                <SupportModal
                    onClose={() => setShowSupportModal(false)}
                    onSubmit={() => {
                        setShowAlert(true);
                        setShowSupportModal(false);
                        setTimeout(() => {
                            setShowAlert(false);
                        }, 3000);
                    }}
                    translation={translation}
                />
            )}
            {/* {data?.branding?.length > 0 && data?.branding[0]?.headerImage?.URL &&
                <div className='footer-img-container'>
                    <img src={data?.branding[0]?.footerImage?.URL} alt="" />
                </div>
            } */}
            <footer aria-label={ariaLabel}>
                <button onClick={() => goto(branding.homePage)}>
                    {translation('footer.contactUsBtn')}
                </button>
                <div className='container'>

                    <div className={'footer-icons'}>
                        <div className='brand'>
                            <div className='logo-container'>
                                <img className='globe' src={globe} alt='' />
                                <img className='logo' src={footerLogo} />
                            </div>
                            <div>
                                <h3
                                    className='cursor-pointer'
                                    onClick={() => goto(branding.website)}
                                >
                                    {branding.name}
                                </h3>

                                <h3 className='address'>
                                    <div>{branding.addressLine1}</div>
                                    <div>{branding.addressLine2}</div>
                                    <div>{branding.addressLine3}</div>
                                </h3>
                                <div className='icons'>
                                    {/* <a
                                        href={branding.facebook}
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        <img
                                            src={facebookLogo}
                                            alt='facebook'
                                        />
                                    </a> */}
                                    <a
                                        href={branding.linkedin}
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        <img
                                            src={linkedInLogo}
                                            alt='linkedin'
                                        />
                                    </a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
